import React from "react";
import { Box, Typography, Chip, Avatar } from "@mui/material";
import Helper from "../../common/Helper";

const TeamPlayersPanel = ({ title, label, players, color, onPlayerClick }) => {
  return (
    <Box>
      {/* HEADER */}
      <Box
        sx={{
          px: 2,
          py: 1,
          background: color === "#1d428a" ? "#eff6ff" : "#fff1f2",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            color: "#64748b",
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 800,
            color,
          }}
        >
          {`(${title})`}
        </Typography>
      </Box>

      {/* PLAYERS */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, p: 1.5 }}>
        {players?.length ? (
          players.map((p) => (
            <Chip
              key={p.id}
              label={p.name}
              clickable
              onClick={() => onPlayerClick?.(p.id)}
              avatar={
                <Avatar src={p.headShotUrl || ""} sx={{ bgcolor: color }}>
                  {Helper.GetNameInitials(p.name)}
                </Avatar>
              }
              sx={{
                background: "#fff",
                border: "1px solid #dbeafe",
                fontSize: 12,
                cursor: "pointer",
                textDecoration: "underline",
                color: "#405ea6",
                fontWeight: 700,
                "&:hover": {
                  background: "#f1f5f9",
                  transform: "scale(1.03)",
                  transition: "0.2s",
                },
                "& .MuiChip-avatar": {
                  color: "#fff",
                  fontWeight: 600,
                },
              }}
            />
          ))
        ) : (
          <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
            No players
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TeamPlayersPanel;
